import { render, staticRenderFns } from "./CourseSessionAttendeesPrerequisites.vue?vue&type=template&id=48894143&scoped=true"
import script from "./CourseSessionAttendeesPrerequisites.vue?vue&type=script&lang=ts"
export * from "./CourseSessionAttendeesPrerequisites.vue?vue&type=script&lang=ts"
import style0 from "./CourseSessionAttendeesPrerequisites.vue?vue&type=style&index=0&id=48894143&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48894143",
  null
  
)

export default component.exports